"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _share = _interopRequireDefault(require("../share/share"));

var _fullscreen = _interopRequireDefault(require("../fullscreen/fullscreen"));

const ControlsExtension = props => {
  const {
    hasShare,
    hasFullscreen
  } = props;
  const [isActive, setActive] = (0, _react.useState)(false);

  function toggleActive() {
    setActive(!isActive);
  }

  return /*#__PURE__*/_react.default.createElement("span", {
    className: "video-controls__extension"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('video-controls--popover', {
      'video-controls__extension--hidden': !isActive
    })
  }, hasShare && /*#__PURE__*/_react.default.createElement("span", {
    className: "video-controls__share"
  }, /*#__PURE__*/_react.default.createElement(_share.default, (0, _extends2.default)({}, props, {
    isCollapsed: true
  }))), hasFullscreen && /*#__PURE__*/_react.default.createElement("span", {
    className: "video-controls__fullscreen"
  }, /*#__PURE__*/_react.default.createElement(_fullscreen.default, (0, _extends2.default)({}, props, {
    isCollapsed: true
  })))), (hasFullscreen || hasShare) && /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    className: "maximize",
    onClick: toggleActive
  }));
};

ControlsExtension.propTypes = {
  hasShare: _propTypes.default.bool,
  hasFullscreen: _propTypes.default.bool
};
ControlsExtension.defaultProps = {
  hasShare: true,
  hasFullscreen: true
};
var _default = ControlsExtension;
exports.default = _default;